import { render, staticRenderFns } from "./SaleDashboardReport.vue?vue&type=template&id=4fd9741b&scoped=true&"
import script from "./SaleDashboardReport.vue?vue&type=script&lang=js&"
export * from "./SaleDashboardReport.vue?vue&type=script&lang=js&"
import style0 from "./SaleDashboardReport.vue?vue&type=style&index=0&id=4fd9741b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd9741b",
  null
  
)

export default component.exports